import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  '&.MuiPaper-root': {
    position: 'relative',
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.border[3]}`,
    background: theme.palette.secondary.main,
    backdropFilter: `blur(${theme.spacing(1)})`,
  },
  '& .MuiAutocomplete-listbox': {
    maxHeight: theme.spacing(37.75),
    fontSize: theme.spacing(2),
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.secondary.main,
      borderRadius: theme.spacing(1),
    },
    '& .MuiAutocomplete-option': {
      padding: theme.spacing(1.5),
    },
  },
}));

export default StyledPaper;
